import React from 'react';
import {
    FoodLabel,
    FoodContainer,
    ImageDetails,
    Description,
    PriceContainer,
    Price,
    HigherStrikePrice,
    FoodImage,
} from '../FoodGrid';
import { Title } from '../Styles/title';
import FoodOOS from './FoodOOS';
import FoodHidden from './FoodHidden';
import { Typography } from '@mui/material';

function ImageRight(props) {
    const {
        sectionId,
        foodId,
        price,
        desc,
        oos,
        name,
        imgSrc,
        hide,
        originalPrice,
        onFoodClick,
        uom,
        serves,
    } = props;
    return (
        <FoodContainer key={sectionId + foodId} oos={oos} onClick={onFoodClick}>
            <FoodLabel>
                <ImageDetails>
                    <Title>
                        <span opacity="0.5">
                            <b>{name} </b>
                        </span>
                        {oos ? <FoodOOS /> : null}
                        {hide && hide === true ? <FoodHidden /> : null}
                    </Title>
                    {uom !== 'people' && serves && (
                        <Typography
                            sx={{
                                mt: 1,
                            }}
                            variant="body2"
                        >
                            {serves.min === serves.max
                                ? serves.min > 1
                                    ? `Serves ${serves.min}`
                                    : ''
                                : `Serves ${serves.min} - ${serves.max}`}
                        </Typography>
                    )}
                    <Description>{desc}</Description>
                    <PriceContainer>
                        <Price>{price}</Price>
                        <HigherStrikePrice>{originalPrice}</HigherStrikePrice>
                    </PriceContainer>
                </ImageDetails>

                {imgSrc ? <FoodImage src={imgSrc} alt={name} /> : null}
            </FoodLabel>
        </FoodContainer>
        //  <PopularItem
        //     data={{
        //         name: name,
        //         desc: desc,
        //         price: price,
        //         img: imgSrc,
        //         oos: oos,
        //         hide: hide,
        //     }}
        // />
    );
}

ImageRight.propTypes = {};

export default ImageRight;
